(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-mission"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.about-mission').forEach(function(section) {
    var logo = section.querySelector('.about-mission__logo');
    var logoImg = section.querySelector('.about-mission__logo-image');
    var logoSvgContainer = section.querySelector('.about-mission__logo > div');
    var logoSvg = section.querySelector('.about-mission__logo svg');

    var desktopSize = parseInt(section.dataset.logoSizeDesktop) || 40;
    var mobileSize = parseInt(section.dataset.logoSizeMobile) || 35;
    var desktopMargin = parseInt(section.dataset.logoMarginDesktop) || 50;
    var mobileMargin = parseInt(section.dataset.logoMarginMobile) || 40;

    function updateLogoSize() {
      var isDesktop = window.innerWidth >= 750;
      var size = isDesktop ? desktopSize : mobileSize;
      var margin = isDesktop ? desktopMargin : mobileMargin;

      if (logo) logo.style.marginTop = margin + 'px';
      if (logoImg) logoImg.style.maxWidth = size + 'px';
      if (logoSvgContainer) {
        logoSvgContainer.style.width = size + 'px';
        logoSvgContainer.style.height = size + 'px';
      }
      if (logoSvg) {
        logoSvg.setAttribute('width', size);
        logoSvg.setAttribute('height', size);
      }
    }

    updateLogoSize();
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateLogoSize, 250);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-faqs-page"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.querySelector('.faqs-page');
  if (!section) return;

  var tabs = section.querySelectorAll('.faqs-tab');
  var questions = section.querySelectorAll('.faqs-accordion');

  function setActiveTab(category) {
    /* Update tabs */
    tabs.forEach(function(tab) {
      if (tab.getAttribute('data-category') === category) {
        tab.classList.add('active');
      } else {
        tab.classList.remove('active');
      }
    });

    /* Filter questions */
    questions.forEach(function(q) {
      var qCat = q.getAttribute('data-category');
      if (qCat && qCat.toLowerCase() === category.toLowerCase()) {
        q.removeAttribute('hidden');
      } else {
        q.setAttribute('hidden', '');
        q.removeAttribute('open');
      }
    });
  }

  /* Attach click listeners */
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      setActiveTab(this.getAttribute('data-category'));
    });
  });

  /* Default: activate first category tab */
  if (tabs.length) {
    setActiveTab(tabs[0].getAttribute('data-category'));
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-find-bag"]) return;
  try {
    
(function() {
  document.querySelectorAll('.find-bag').forEach(function(section) {
    var filters = section.querySelector('[data-find-bag-filters]');
    var carousel = section.querySelector('[data-find-bag-carousel]');
    var dotsContainer = section.querySelector('[data-find-bag-dots]');
    var cards = carousel ? Array.from(carousel.querySelectorAll('.find-bag__card')) : [];

    // Filter functionality
    if (filters) {
      var buttons = Array.from(filters.querySelectorAll('.find-bag__filter-btn'));
      buttons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          buttons.forEach(function(b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');

          var filter = btn.getAttribute('data-filter');
          cards.forEach(function(card) {
            if (filter === 'all' || card.getAttribute('data-bag-type') === filter) {
              card.classList.remove('is-hidden');
            } else {
              card.classList.add('is-hidden');
            }
          });

          updateDots();
        });
      });
    }

    // Dots for mobile
    function updateDots() {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      var visibleCards = cards.filter(function(c) { return !c.classList.contains('is-hidden'); });
      if (window.innerWidth >= 768 || visibleCards.length <= 1) return;

      visibleCards.forEach(function(card, i) {
        var dot = document.createElement('button');
        dot.className = 'find-bag__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function() {
          card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
        dotsContainer.appendChild(dot);
      });
    }

    // Update active dot on scroll
    if (carousel) {
      var scrollTimer;
      carousel.addEventListener('scroll', function() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function() {
          var dots = dotsContainer ? Array.from(dotsContainer.querySelectorAll('.find-bag__dot')) : [];
          var visibleCards = cards.filter(function(c) { return !c.classList.contains('is-hidden'); });
          if (dots.length === 0) return;

          var carouselRect = carousel.getBoundingClientRect();
          var center = carouselRect.left + carouselRect.width / 2;
          var closestIdx = 0;
          var closestDist = Infinity;

          visibleCards.forEach(function(card, i) {
            var cardRect = card.getBoundingClientRect();
            var cardCenter = cardRect.left + cardRect.width / 2;
            var dist = Math.abs(cardCenter - center);
            if (dist < closestDist) {
              closestDist = dist;
              closestIdx = i;
            }
          });

          dots.forEach(function(d, i) {
            d.classList.toggle('is-active', i === closestIdx);
          });
        }, 100);
      });
    }

    // Klaviyo notify button
    section.querySelectorAll('[data-klaviyo-trigger]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'SRCgwE']);
      });
    });

    updateDots();
    window.addEventListener('resize', updateDots);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-lp-faqs"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.c-lp-faqs').forEach(function(section) {
    section.querySelectorAll('[data-faq-toggle]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('[data-faq-item]');
        var wasOpen = item.classList.contains('is-open');

        // Close all items in this section
        section.querySelectorAll('[data-faq-item]').forEach(function(el) {
          el.classList.remove('is-open');
        });

        // Toggle clicked item
        if (!wasOpen) {
          item.classList.add('is-open');
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-main-article"]) return;
  try {
    
(function() {
  /* Share button — copy article URL to clipboard */
  var shareBtn = document.querySelector('[data-share]');
  var tooltip = document.querySelector('[data-share-tooltip]');
  if (shareBtn) {
    shareBtn.addEventListener('click', function() {
      var url = window.location.href;
      if (navigator.share) {
        navigator.share({ title: document.title, url: url });
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function() {
          if (tooltip) {
            tooltip.hidden = false;
            tooltip.classList.add('is-visible');
            setTimeout(function() {
              tooltip.classList.remove('is-visible');
              setTimeout(function() { tooltip.hidden = true; }, 300);
            }, 2000);
          }
        });
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-main-blog"]) return;
  try {
    
(function() {
  var btn = document.getElementById('toggle-sidebar');
  var sidebar = document.getElementById('blog-sidebar');
  if (btn && sidebar) {
    btn.addEventListener('click', function() {
      sidebar.classList.toggle('open');
    });
    /* Close sidebar when clicking outside on mobile */
    document.addEventListener('click', function(e) {
      if (sidebar.classList.contains('open') && !sidebar.contains(e.target) && e.target !== btn) {
        sidebar.classList.remove('open');
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
